module.exports = __webpack_public_path__ + "img/qrcode-sun-mobile.12ca181.png";